import React, { useState, useEffect } from "react";
import { FaCalendarAlt, FaChartBar, FaEnvelope, FaCog } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FinanceDashboard from "./FinanceDashboard";
import ChatView from "./ChatView";
import SettingView from "./SettingView";
import { useNavigate } from "react-router-dom";

export default function SideMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

   const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
   useEffect(() => {
     const adminId = localStorage.getItem("adminID");
     if (!adminId) {
       navigate("/"); 
     }
 
     // 👇 load dark mode preference
     const savedTheme = localStorage.getItem("darkMode") === "true";
     setDarkMode(savedTheme);
     document.body.classList.toggle("dark", savedTheme);
   }, [navigate]);


  return (
    <>
      {/* Floating Toggle Button */}
      <div
        className={`menu-toggle-btn ${isOpen ? "bottom" : "center"}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "> Close" : "<"} {isOpen ? "" : "Menu"}
      </div>

      {/* Side Menu */}
      <div
        className={`side-menu new-bg ${darkMode ? "dark" : ""} justify-content-center ${
          isOpen ? "open" : ""
        }`}
      >
        <div className="menu-icons">
          {/* Calendar Button */}
          <button
            className="btn btn-light mb-3"
            onClick={() => setShowCalendar(!showCalendar)}
          >
            <FaCalendarAlt size={20} />
          </button>

          {/* Other Buttons */}
          <FinanceDashboard/>
          <ChatView/>

          <SettingView/>

          {/* <button className="btn btn-light mb-3">
            <FaCog size={20} />
          </button> */}
        </div>
      </div>

      {/* Calendar Popup */}
      {showCalendar && (
        <div className={`calendar-popup pcard ${darkMode ? "dark" : ""}`}>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            inline
          />
          <div
            className={`close-calendar mainttl ${darkMode ? "dark" : ""}`}
            onClick={() => setShowCalendar(false)}
          >
            Close Calendar
          </div>
        </div>
      )}
    </>
  );
}
